import BreadcrumbsBlock from '@/blocks/BreadcrumbsBlock';
import JobApplyForm from '@/components/JobApplyForm';
import Prose from '@/components/Prose';
import { fadeIn, fadeInUp } from '@/constants/motions';
import { pages } from '@/content';
import FullWidthLayout from '@/layouts/FullWidthLayout';
// import { markdownToHtml } from '@/utils/markdown';
// import { PostProvider } from '@/utils/post';
import { REVALIDATE_TIME_IN_SEC } from '@/constants/env';
import careerPositions from '@/graphql/queries/career-positions';
import job from '@/graphql/queries/job';
import mainLayout from '@/graphql/queries/mainLayout';
import graphql from '@/lib/graphql';
import { motion } from 'framer-motion';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

export default function JobPage({ breadcrumbs, mainLayout, page }) {
  const attributes = page?.attributes || {};
  const contentSection = attributes.contentSection || [];
  const metaData = attributes.metaData || {};
  return (
    <FullWidthLayout mainLayout={mainLayout} metaData={metaData}>
      <motion.div
        initial="hidden"
        transition={{
          ...fadeIn.transition,
          when: 'beforeChildren',
          staggerChildren: 0.4,
        }}
        variants={fadeIn}
        viewport={fadeIn.viewport}
        whileInView="visible"
      >
        <BreadcrumbsBlock items={breadcrumbs} variants={fadeIn} />
        <motion.section className="my-16 px-4" variants={fadeIn}>
          <div className="container-screen">
            {/* <Prose
              className="max-w-none prose-headings:font-medium prose-h2:mb-4"
              dangerouslySetInnerHTML={{ __html: job.content }}
            /> */}
            <Prose className="max-w-none prose-headings:font-medium prose-h2:mb-4">
              <Markdown rehypePlugins={[rehypeRaw]}>{attributes.content || ''}</Markdown>
            </Prose>
          </div>
        </motion.section>
        <motion.section
          className="my-16 px-4"
          initial="hidden"
          transition={fadeInUp.transition}
          variants={fadeInUp}
          viewport={fadeInUp.viewport}
          whileInView="visible"
        >
          <div className="container-screen">
            <h2 className="text-3xl font-medium">
              {/* Apply for this position */}
              Solliciteer voor deze functie
            </h2>
            <div className="mt-8 max-w-screen-md">
              <JobApplyForm
                job={{
                  title: attributes.title,
                }}
                lang="nl"
              />
            </div>
          </div>
        </motion.section>
      </motion.div>
    </FullWidthLayout>
  );
}

export async function getStaticProps({ params }) {
  // const jobProvider = new PostProvider('jobs');
  // const jobses = jobProvider.getBySlug(params.slug, ['title', 'date', 'slug', 'content']);
  // const content = await markdownToHtml(job.content || '');

  const { data: mainLayoutData } = await graphql(mainLayout);
  const { data: pageData } = await graphql(job, { pos: params.slug });

  return {
    props: {
      breadcrumbs: [
        pages.home,
        pages.careers,
        pages.jobs,
        {
          url: '#',
          text: pageData.careerPositions.data[0].attributes.title,
        },
      ],
      mainLayout: mainLayoutData.mainLayout.data,
      page: pageData.careerPositions.data[0],
    },
    revalidate: parseInt(REVALIDATE_TIME_IN_SEC), // In seconds
  };
}

export async function getStaticPaths() {
  // const jobProvider = new PostProvider('jobs');
  // const jobs = jobProvider.getAll(['slug']);

  const { data } = await graphql(careerPositions);
  const jobs = data.careerPositions.data;
  return {
    paths: jobs.map((job) => {
      return {
        params: {
          slug: job.attributes.slug,
        },
      };
    }),
    fallback: false,
  };
}
